import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Box, SidebarItem, Divider } from "samba-ui";
import useActiveRoute from "./hooks/useActiveRoute";
import styled from "styled-components";

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
`;

const StyledBox = styled(Box)`
  overflow-y: scroll;
  height: calc(100vh - 185px);
`;

const Pages = ({ pages }) => {
  const [activeRoute, isActive] = useActiveRoute("/admin");

  pages = pages.filter(page => page.to);

  return (
    <Box>
      <Divider mx={2} my={4} mt={0} bg={"palette.ink.700"} />
      <StyledBox>
        {pages.map(({ to, title, icon, logo }) => (
          <StyledNavLink
            key={title}
            exact
            isActive={isActive.bind(null, to)}
            to={to}
          >
            <SidebarItem
              icon={icon ? icon : ""}
              logo={logo ? logo : ""}
              selected={activeRoute === to}
              title={title}
            />
          </StyledNavLink>
        ))}
      </StyledBox>
    </Box>
  );
};

Pages.propTypes = {
  pages: PropTypes.array
};

export default Pages;
